// extracted by mini-css-extract-plugin
module.exports = {"tab":"BreadcombTab_tab__K9i4r","tabOver":"BreadcombTab_tabOver__10eAT","link":"BreadcombTab_link__3wd6r"};